import styled from 'styled-components';

import { Text, Title } from '@atom/typography/typography';

export const UnsafePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 34px;
  min-width: 380px;
`;

export const UnsafePageTitle = styled(Title).attrs((props) => ({
  level: 2,
  color: props.theme.Title.colorSignUpTitle,
  weight: 400,
}))``;

export const UnsafePageDescription = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorSignUpDescription,
  paragraph: true,
  level: 'l',
}))`
  padding-top: 8px;
  text-align: center;
`;

export const PageWrapper = styled.div`
  padding: 14px 6px 0;
`;

export const PageTitle = styled(Title).attrs((props) => ({
  level: 2,
  color: props.theme.Title.colorPageTitle,
  weight: 400,
  mb: 16,
}))``;

export const PageDescription = styled(Title).attrs((props) => ({
  level: 4,
  color: props.theme.Title.colorPageDescription,
  weight: 400,
  mb: 14,
}))``;
